import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ComposeEmail from "@/components/emails/ComposeEmail";
import EmailTemplates from "@/components/emails/EmailTemplates";
import CampaignHistory from "@/components/emails/CampaignHistory";

export default function EmailManagement() {
  const [activeTab, setActiveTab] = useState("compose");

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div className="min-w-0 flex-1">
          <h1 className="text-2xl font-semibold text-neutral-800">Email Management</h1>
          <p className="text-sm text-neutral-500">Manage your recruitment email campaigns and templates</p>
        </div>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid grid-cols-3 w-full mb-4">
          <TabsTrigger value="compose">Compose</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>

        <TabsContent value="compose">
          <ComposeEmail />
        </TabsContent>

        <TabsContent value="templates">
          <EmailTemplates />
        </TabsContent>

        <TabsContent value="history">
          <CampaignHistory />
        </TabsContent>
      </Tabs>
    </div>
  );
}